import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative w-full min-h-[420px] md:min-h-[600px] flex items-center overflow-hidden">
      {/* Background image with overlay */}
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Dramatic%20abstract%20art%20composition%20with%20warm%20crimson%20and%20deep%20charcoal%20tones%2C%20artistic%20gradient%20blending%2C%20modern%20editorial%20style%2C%20dark%20moody%20background%20with%20subtle%20texture%2C%20no%20text%2C%20cinematic%20atmosphere%2C%20luxury%20magazine%20aesthetic&width=1600&height=900&seq=hero-bg-main&orientation=landscape"
          alt="吃瓜网每日大赛背景"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/25 to-black/45"></div>
      </div>

      {/* Content */}
      <div className="relative w-full px-4 md:px-6 z-10">
        <div className="max-w-7xl mx-auto">
          <div className="flex flex-col lg:flex-row gap-8 lg:gap-0">
            {/* Left Column - Headlines */}
            <div className="lg:w-[35%] flex flex-col justify-center">
              <h1 className="text-3xl md:text-5xl lg:text-6xl font-bold font-heading text-background-50 leading-tight">
                每日
                <br />
                吃瓜大赛
              </h1>
              <p className="mt-4 md:mt-6 text-sm md:text-base text-background-200/80 leading-relaxed max-w-sm">
                网红塌房第一现场，娱乐八卦实时追踪。
                <br />
                每天更新最新猛料，让你永远站在吃瓜第一线。
              </p>
              <div className="mt-6 md:mt-8">
                <Link
                  to="/category/daily-contest"
                  className="inline-flex items-center gap-2 px-6 py-3 bg-primary-500 text-background-50 rounded-full text-sm md:text-base font-medium hover:bg-primary-600 transition-colors whitespace-nowrap"
                >
                  立即围观今日大赛
                  <i className="ri-arrow-right-up-line w-4 h-4 flex items-center justify-center"></i>
                </Link>
              </div>
            </div>

            {/* Middle Column - Main Image */}
            <div className="lg:w-[35%] flex items-center justify-center">
              <div className="w-full max-w-[340px] md:max-w-[420px] aspect-[3/4] rounded-2xl overflow-hidden">
                <img
                  src="https://readdy.ai/api/search-image?query=Dramatic%20editorial%20portrait%20concept%2C%20mysterious%20figure%20in%20shadow%2C%20warm%20crimson%20accent%20lighting%2C%20fashion%20magazine%20style%2C%20high%20contrast%2C%20artistic%20photography%2C%20dark%20moody%20background%2C%20luxury%20editorial%20aesthetic&width=800&height=1067&seq=hero-main-visual&orientation=portrait"
                  alt="吃瓜网每日大赛精选"
                  className="w-full h-full object-cover"
                />
              </div>
            </div>

            {/* Right Column - Featured Mini Grid */}
            <div className="lg:w-[30%] flex flex-col justify-center">
              <div className="mb-4 md:mb-6">
                <span className="text-xs text-accent-400 font-medium tracking-wider uppercase">
                  今日精选
                </span>
                <h2 className="text-lg md:text-xl font-bold text-background-50 mt-1 leading-snug">
                  三大热点事件
                  <br />
                  不容错过
                </h2>
              </div>
              <div className="grid grid-cols-2 gap-2 md:gap-3">
                <Link to="/category/wanghong-tafang" className="col-span-2 rounded-xl overflow-hidden aspect-[2/1] relative group cursor-pointer">
                  <img
                    src="https://readdy.ai/api/search-image?query=Chinese%20entertainment%20news%20concept%2C%20dramatic%20spotlight%20on%20empty%20stage%2C%20warm%20golden%20lighting%2C%20mysterious%20atmosphere%2C%20editorial%20photography&width=600&height=300&seq=hero-mini-01&orientation=landscape"
                    alt="网红塌房热点"
                    className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent"></div>
                  <span className="absolute bottom-2 left-2 bg-background-50/90 text-foreground-900 text-xs px-2 py-0.5 rounded-md font-medium">
                    网红塌房
                  </span>
                </Link>
                <Link to="/category/heiliao-dagua" className="rounded-xl overflow-hidden aspect-square relative group cursor-pointer">
                  <img
                    src="https://readdy.ai/api/search-image?query=Chinese%20social%20media%20scandal%20concept%2C%20broken%20phone%20screen%20with%20messages%2C%20dramatic%20red%20lighting%2C%20editorial%20style&width=300&height=300&seq=hero-mini-02&orientation=squarish"
                    alt="黑料大瓜"
                    className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/50 to-transparent"></div>
                  <span className="absolute bottom-2 left-2 bg-background-50/90 text-foreground-900 text-xs px-2 py-0.5 rounded-md font-medium">
                    黑料大瓜
                  </span>
                </Link>
                <Link to="/category/yule-chigua" className="rounded-xl overflow-hidden aspect-square relative group cursor-pointer">
                  <img
                    src="https://readdy.ai/api/search-image?query=Chinese%20TV%20variety%20show%20drama%20concept%2C%20colorful%20stage%20lights%20with%20tension%2C%20editorial%20photography%2C%20warm%20tones&width=300&height=300&seq=hero-mini-03&orientation=squarish"
                    alt="娱乐吃瓜"
                    className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/50 to-transparent"></div>
                  <span className="absolute bottom-2 left-2 bg-background-50/90 text-foreground-900 text-xs px-2 py-0.5 rounded-md font-medium">
                    娱乐吃瓜
                  </span>
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}